import { Outlet } from 'react-router-dom'

const PositionTracker = () => {
  return (
    <><Outlet/></>
  )
}

export default PositionTracker